module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_05.46b6bddb.jpg";